import { IpaType, getAllIpa } from "../phonemes/ipa";

/** make an array of phonemes, where a phoneme may include diacritics */
export function chunkPhonemes(s: string): IpaType[] {
  const result: IpaType[] = []
  let chunk: IpaType = '';
  const { diacritics } = getAllIpa();
  for (const c of s) {
    if (diacritics.includes(c)) {
      chunk += c;
    } else {
      if (chunk.length > 0) {
        result.push(chunk);
      }
      chunk = c;
    }
  }
  if (chunk.length > 0) {
    result.push(chunk);
  }
  return result;
}
